import { useMemo, useState } from 'react';
import { DayPicker, DateRange } from 'react-day-picker';
import { Box, Button, IconButton, Modal } from '@mui/material';
import { useDispatch } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import 'react-day-picker/dist/style.css';
import classes from './RangePicker.module.scss';
import RangePickerProps from '../../interfaces/props/RangePickerProps';
import { setDate } from '../../../store/filters/filters.slice';

const currentDate = new Date();
const toMonth = new Date(currentDate.getFullYear(), currentDate.getMonth());

const RangePicker = ({
  getRange,
  initialDateRange,
  isModal,
  isCalendarOpen,
  closeCalendar
}: RangePickerProps) => {
  const defaultSelected: DateRange = {
    from: initialDateRange?.from ?? currentDate,
    to: initialDateRange?.to ?? currentDate
  };
  const [range, setRange] = useState<DateRange | undefined>(defaultSelected);
  const dispatch = useDispatch();
  const isApplyButtonDisabled = useMemo(() => undefined === range?.from  || undefined === range?.to, [range]);

  const isDateDisabled = (date: Date) => {
    return date > currentDate;
  };

  const onApplyHandler = () => {
    if (range) {
      getRange(range);
    }
    if (isModal && closeCalendar) {
      closeCalendar();
    }
  };

  const onClearHandler = () => {
    setRange(undefined);
  };

  const onCloseHandler = () => {
    if (closeCalendar) {
      closeCalendar();
    }
    dispatch(setDate(null));
  };

  return (
    <>
      {isModal && isCalendarOpen ? (
        <Modal open={isCalendarOpen} onClose={onCloseHandler}>
          <Box className={classes.calendar}>
            <Box className='d-flex'>
              <DayPicker
                mode='range'
                defaultMonth={currentDate}
                selected={range}
                onSelect={setRange}
                className={classes.rdp}
                disabled={isDateDisabled}
                ISOWeek
                toMonth={toMonth}
                captionLayout='dropdown-buttons'
                fromYear={2020}
              />
              <Box>
                <IconButton className={classes.button} onClick={onCloseHandler}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
            <Box className='d-flex flex-row justify-content-end'>
              <Button className={classes.button} onClick={onClearHandler}>
                Clear
              </Button>
              <Button className={isApplyButtonDisabled ? classes.disableButton : classes.button} onClick={onApplyHandler} disabled={isApplyButtonDisabled}>
                Apply
              </Button>
            </Box>
          </Box>
        </Modal >
      ) :
        (
          <Box className='d-flex light-boxed flex-column justify-content-center align-items-center'>
            <Box>
              <DayPicker
                mode='range'
                defaultMonth={currentDate}
                selected={range}
                onSelect={setRange}
                className={classes.rdp}
                disabled={isDateDisabled}
                ISOWeek
                toMonth={toMonth}
                captionLayout='dropdown-buttons'
                fromYear={2020}
              />
              <Box className='d-flex flex-row justify-content-between'>
                <Button className={classes.button} onClick={onClearHandler}>
                  Clear
                </Button>
                <Button className={isApplyButtonDisabled ? classes.disableButton : classes.button} onClick={onApplyHandler} disabled={isApplyButtonDisabled}>
                  Apply
                </Button>
              </Box>
            </Box>
          </Box>
        )
      }
    </>
  );
};

export default RangePicker;
